import React from "react";
import Moment from 'moment';

const Key = ({keyObj, removeKey}) => {

    // Given an exchange, return the color for key
    function getExchangeColour(exchange) {

        if(exchange === 'Kraken')
            return 'border-pink';
        else if(exchange === 'Poloniex')
            return 'border-purple';
        else if(exchange === 'BitTrex')
            return 'border-teal';
        else if(exchange === 'Coinbase')
            return 'border-blue';
        else
            return 'border-blue';
    }

    // Render the key component
    return (
        <div className="key-panel" key={keyObj._id}>

            <div className="col-md-12 col-sm-12 col-xs-12 left">
                <i className="icon-cross2 text-size-large remove-icon" onClick={() => removeKey(keyObj)}></i>
                {/*-- row --*/}
                <div className="row">
                    <div className="col-lg-11 col-sm-11">

                        <div className="input-group input-group-sm">
                            <span className="input-group-addon"><i className="icon-key"></i></span>
                            <input type="text" className="form-control no-bg" placeholder="" value={keyObj.apiKey}></input>
                        </div>

                    </div>
                </div>
                {/*-- / row --*/}
                {/*-- row --*/}
                <div className="row">
                    <div className="col-lg-11 col-sm-11">

                        <div className="input-group input-group-sm">
                            <span className="input-group-addon"><i className="icon-lock2"></i></span>
                            <input type="text" className="form-control no-bg" placeholder="" value={keyObj.secret}></input>
                        </div>

                    </div>
                </div>
                {/*-- / row --*/}
                {/*-- row --*/}
                <div className="row bottom-row">
                    <div className="col-lg-4 col-sm-5">
                        <span className={"label label-flat label-block " + getExchangeColour(keyObj.exchange)}>{keyObj.exchange}</span>
                    </div>
                    <div className="col-lg-8 col-sm-7 key-timestamp">
                        {Moment(keyObj.timestamp).format("MMMM Do YYYY, h:mm:ss a")}
                    </div>
                </div>
                {/*-- / row --*/}
                
            </div>
        </div>
    );

}

export default Key;


// WEBPACK FOOTER //
// ./src/Views/ApiKeys/Key.js